/**
 * Landing — the app root (/) is not a destination. The marketing site at
 * iprotectyou.family owns the front door; this app is reached via deep links
 * from the website CTAs (/quote, /book) and by the agent (/agent).
 *
 * In production Express 302-redirects `/` to the website before the SPA even
 * loads (see server/index.js). This component is the client-side fallback for
 * the CRA dev server and any in-app navigation to `/`.
 */

import React, { useEffect } from 'react';

const MARKETING_URL = 'https://iprotectyou.family';

export default function Landing() {
  useEffect(() => {
    window.location.replace(MARKETING_URL);
  }, []);

  return (
    <main style={{ padding: '2rem 1.5rem', textAlign: 'center' }}>
      <p>
        Redirecting to <a href={MARKETING_URL}>iprotectyou.family</a>…
      </p>
    </main>
  );
}
